import { BITRIX24_SCRIPT_SRC } from '@/shared/config/BitrixChatWidget/config'
import { BitrixChat } from '@/shared/integrations/BitrixChat/BitrixChat'

export const bitrixChat = new BitrixChat(BITRIX24_SCRIPT_SRC + `?` + ((Date.now() / 60000) | 0))
